import React, {useContext} from 'react';
import {useParams} from 'react-router-dom';
import {Car} from '../components/Car/Car';
import {Consumption} from '../components/Consumption/Consumption';
import {Employee} from '../components/Employee/Employee';
import {FuelTransactionsWidget} from '../components/FuelTransaction/FuelTransactionWidget';
import {AddFuelTransaction} from '../components/FuelTransaction/actions/AddFuelTransaction';
import {useFuelTransaction} from '../components/FuelTransaction/hooks/useFuelTransaction';
import {InconsistencyCheck} from '../components/InconsistencyCheck/InconsistencyCheck';
import {Savings} from '../components/Savings/Savings';
import {Totals} from '../components/Totals/Totals';
import {Card} from '../components/ui/Card';
import {Link} from '../components/ui/Link';
import {SelectPeriod} from '../components/ui/SelectPeriod';
import {Title} from '../components/ui/Title';
import {PeriodContext} from '../context/PeriodProvider';
import {UserContext} from '../context/UserProvider';
import {routeUrls} from '../routes';
import {Role} from '../types/Role';
import {Subtitle} from '../components/ui/Subtitle';
import {DashboardPageContext} from "../context/DashboardPageContext";
import {useAuth0} from "@auth0/auth0-react";
import {useMsal} from "@azure/msal-react";

export const DashboardPage = () => {
    const {userRole} = useContext(UserContext);
    const auth0 = useAuth0();
    const msal = useMsal();
    let name = "";

    if(msal.accounts.length > 0) {
        name = msal.accounts[0].name || ""
    } else {
        name = auth0.user?.name || ""
    }

    const {id} = useParams();
    const adminOnEmployeeDashboard = userRole === Role.ADMIN && id;
    const {period} = useContext(PeriodContext);

    return (
        <DashboardPageContext.Provider value={{driverId: id ?? null}}>
            <div className="flex flex-col gap-6 md:gap-12">
                <div className="flex flex-col">
                    <div className="py-3 md:py-0 flex justify-between items-center">
                        <Title>{adminOnEmployeeDashboard ? 'Dashboard werknemer' : 'Dashboard'}</Title>

                        <SelectPeriod/>
                    </div>

                    {name && !adminOnEmployeeDashboard && (
                        <Subtitle className="pb-6 md:pb-0 text-primary">Welkom
                            terug, {name}!</Subtitle>
                    )}
                </div>

                {adminOnEmployeeDashboard && (
                    <div className="flex flex-col gap-6">
                        <div className="w-full flex flex-row">
                            <Employee userId={id}/>
                        </div>

                        {/*<Link href={`${routeUrls.CHANGE_REQUESTS}/${id}`} hideAnchorIcon className="text-sm underline">*/}
                        {/*    Bekijk aanvragen van werknemer*/}
                        {/*</Link>*/}

                        <div className="w-full border-t-[1px] border-grey"></div>
                    </div>
                )}

                <div className="flex lg:flex-wrap flex-col lg:flex-row gap-6 xl:gap-12 xl:h-[280px]">
                    <Card>
                        <Card.Title>{adminOnEmployeeDashboard ? "Besparing in euro's" : "Uw besparing in euro's"}</Card.Title>
                        <Card.Subtitle>Gebaseerd op gebruik en brandstof</Card.Subtitle>
                        <Card.Content className="flex-row">
                            <Savings/>
                        </Card.Content>
                    </Card>
                    <Card>
                        <Card.Title>{adminOnEmployeeDashboard ? 'CO2 besparing en verbruik' : 'Uw CO2 besparing en verbruik'}</Card.Title>
                        <Card.Subtitle>Gebaseerd op huidige autoverbruik</Card.Subtitle>
                        <Card.Content className="flex-row">
                            <Consumption/>
                        </Card.Content>
                    </Card>
                </div>

                <div className="max-md:hidden w-full border-t-[1px] border-grey"></div>

                <div className="flex flex-wrap flex-col lg:flex-row lg:items-start gap-6 md:gap-12">
                    <div className="flex flex-col flex-1 gap-6 ">
                        <Card className="lg:min-w-[350px]">
                            <Card.Title className="flex justify-between items-center">
                                <div>Tankbeurten</div>

                                <AddFuelTransaction/>
                            </Card.Title>
                            <Card.Content className="mb-0">
                                <FuelTransactionsWidget dataFetcher={useFuelTransaction().getFuelTransactions(period)}/>
                            </Card.Content>
                        </Card>

                        <Card>
                            <Card.Title className="flex justify-between items-center">
                                <div>Vervangend vervoer</div>
                            </Card.Title>
                            <Card.Content className="mb-0">
                                <FuelTransactionsWidget
                                    dataFetcher={useFuelTransaction().getReplacementFuelTransactions(period)}/>
                            </Card.Content>
                        </Card>
                    </div>

                    <div className="flex flex-col flex-1 gap-6">
                        <Card className="bg-accent lg:min-w-[300px]">
                            <Card.Title className="text-accent-foreground">Autogegevens</Card.Title>
                            <Card.Content className="text-accent-foreground">
                                <Car/>
                            </Card.Content>
                        </Card>
                        {/*<Card className="bg-accent">*/}
                        {/*    <Card.Title className="text-accent-foreground">{adminOnEmployeeDashboard ? 'Totalen' : 'Uw totalen'}</Card.Title>*/}
                        {/*    <Card.Content className="text-accent-foreground">*/}
                        {/*        <Totals />*/}
                        {/*    </Card.Content>*/}
                        {/*</Card>*/}
                    </div>

                    <div className="flex flex-col flex-1 gap-6">
                        <Card>
                            <Card.Title>Inconsistentiecheck</Card.Title>
                            <Card.Content>
                                <InconsistencyCheck/>
                            </Card.Content>
                        </Card>
                    </div>
                </div>
            </div>
        </DashboardPageContext.Provider>
    );
};
